import React from 'react';
import {
    FormControl,
    Select,
    MenuItem,
    TextField,
    Typography,
    FormHelperText,
    FormControlLabel,
    Radio,
    RadioGroup,
    Checkbox,
    Switch,
    Button,
    IconButton,
    Box,
    Tooltip,
    Autocomplete,
    Modal,
    Paper,
  } from "@mui/material";
import { isFieldVisible } from './formUtils';
import formConfig from './formConfig';
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RemoveIcon from "@mui/icons-material/Remove";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const Attachments = ({
  formData,
  setFormData,
  formMode,
  errors,
  setErrors,
  fileUrl,
  handleOpenProformaModal,
  handleOpenTradeModal,
  handleOpenKycModal,
  handleChange,
}) => {
  const handleFileRemove = (fieldName) => {
    handleChange({
      target: { name: fieldName, value: null, type: 'file' },
    });
  };

  return (
    <>
    <div className="tab-pane active">
        <div className="row g-3">
          {/* Proforma Invoice / Contract */}
          {isFieldVisible('proformaInvoiceFile', formData.instrument, formConfig) && (<div className="col-md-4">
            <Typography variant="body2">Proforma Invoice / Contract</Typography>
            <Box
              sx={{
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "8px",
                minHeight: "120px",
                backgroundColor: "white",
              }}
            >
              {formData.proformaInvoiceFile ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "4px 8px",
                    marginBottom: "4px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                  }}
                >
                   
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                    <PictureAsPdfIcon sx={{ marginRight: 1, color: "#d32f2f" }} />
                   
                    <Typography variant="body2">
                      <a
                        href={fileUrl + formData.proformaInvoiceFile.name}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {formData.proformaInvoiceFile.name}
                      </a>
                    </Typography>
                  </Box>
                  
                  
                  {formMode !== "view" && (
                    <IconButton
                      size="small"
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          proformaInvoiceFile: null,
                        }))
                      }
                      sx={{ color: "#d32f2f", width: "auto" }}
                    >
                      <RemoveIcon />
                    </IconButton>
                  )}
                </Box>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No proforma invoice file uploaded
                </Typography>
              )}
              {formMode !== "view" && (
                <Button
                  startIcon={<UploadFileIcon />}
                  onClick={handleOpenProformaModal}
                  sx={{ marginTop: 1, backgroundColor: "#ff9800", color: "#fff" }}
                  variant="contained"
                >
                  Upload Proforma Invoice
                </Button>
              )}
            </Box>
          </div>)}
          {/* Supporting Trade Docs */}
          {isFieldVisible('tradeDocsFile', formData.instrument, formConfig) && (<div className="col-md-4">
            <Typography variant="body2">
              Supporting Trade Docs (PO, BL, KYB, etc.)
            </Typography>
            <Box
              sx={{
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "8px",
                minHeight: "120px",
                backgroundColor: "white",
              }}
            >
              {formData.tradeDocsFile ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "4px 8px",
                    marginBottom: "4px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <PictureAsPdfIcon sx={{ marginRight: 1, color: "#d32f2f" }} />
                    <Typography variant="body2">
                      <a
                        href={fileUrl + formData.tradeDocsFile.name}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {formData.tradeDocsFile.name}
                      </a>
                    </Typography>
                  </Box>
                  {formMode !== "view" && (
                    <IconButton
                      size="small"
                      onClick={() =>
                        setFormData((prev) => ({ ...prev, tradeDocsFile: null }))
                      }
                      sx={{ color: "#d32f2f", width: "auto" }}
                    >
                      <RemoveIcon />
                    </IconButton>
                  )}
                </Box>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No trade documents uploaded
                </Typography>
              )}
              {formMode !== "view" && (
                <Button
                  startIcon={<UploadFileIcon />}
                  onClick={handleOpenTradeModal}
                  sx={{ marginTop: 1, backgroundColor: "#ff9800", color: "#fff" }}
                  variant="contained"
                >
                  Upload Trade Documents
                </Button>
              )}
            </Box>
          </div>)}
          {/* Company Profile / KYC Docs */}
          {isFieldVisible('kycDocsFile', formData.instrument, formConfig) && (<div className="col-md-4">
            <Typography variant="body2">
              Company Profile / KYC Docs (Optional)
            </Typography>
            <Box
              sx={{
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "8px",
                minHeight: "120px",
                backgroundColor: "white",
              }}
            >
              {formData.kycDocsFile ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "4px 8px",
                    marginBottom: "4px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <PictureAsPdfIcon sx={{ marginRight: 1, color: "#d32f2f" }} />
                    <Typography variant="body2">
                      <a
                        href={fileUrl + formData.kycDocsFile.name}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {formData.kycDocsFile.name}
                      </a>
                    </Typography>
                  </Box>
                  {formMode !== "view" && (
                    <IconButton
                      size="small"
                      onClick={() =>
                        setFormData((prev) => ({ ...prev, kycDocsFile: null }))
                      }
                      sx={{ color: "#d32f2f", width: "auto" }}
                    >
                      <RemoveIcon />
                    </IconButton>
                  )}
                </Box>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No KYC documents uploaded
                </Typography>
              )}
              {formMode !== "view" && (
                <Button
                  startIcon={<UploadFileIcon />}
                  onClick={handleOpenKycModal}
                  sx={{ marginTop: 1, backgroundColor: "#ff9800", color: "#fff" }}
                  variant="contained"
                >
                  Upload KYC Documents
                </Button>
              )}
            </Box>
          </div>)}
        </div>
      </div>
    
    </>
  );
};

export default Attachments;